import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from 'react';
import { createPortal } from 'react-dom';
import translate from '../../../../translate';
import alarmImg from '../../../../../images/rse/alarm.png';
const LastCall = () => {
    const container = document.querySelector('[data-product-last-call]');
    const target = useRef(container).current;
    const hasMounted = useRef(false);
    if (!target)
        return null;
    // Clear container content to avoid multiple last call mount
    if (!hasMounted.current) {
        target.innerHTML = '';
        hasMounted.current = true;
    }
    return (_jsx(_Fragment, { children: container
            ? createPortal(_jsxs("div", { className: "u-flex u-flex-cross-start u-mt-xs-sm", children: [_jsx("img", { src: alarmImg, alt: "", loading: "lazy", className: "u-flex-item-none u-mt-xxs-bis" }), _jsx("p", { className: "u-mt-n u-ml-xs-sm u-text-md-plus u-text-md-plus@sm u-color-gray-600", children: _jsx("em", { children: translate('front.product.index.last_call_message') }) })] }), container)
            : null }));
};
export default LastCall;
